import Map from "./map";

export default class GoogleMaps {
  constructor() {
    // init map
    // load google maps only when there's a map on the page
    const map = document.querySelector('.hero__map');
    if (!map) {
      return;
    }

    // cookie consent integration
    if (lwIsIntegrationEnabled('maps_google')) {
      this.initGoogleMaps();
    } else {
      window.addEventListener('lw-optinout', function (e) {
        if (e.detail.integrationId === 'maps_google' && e.detail.mode === 'optin') {
          map.innerHTML = '';
          this.initGoogleMaps();
        }
      }.bind(this));
      map.innerHTML = '<p style="padding: 1rem;">Bitte akzeptieren Sie die Cookies, um die Karte zu sehen.</p>';
    }
    window.initGoogleMap = () => {
      let map = new Map({
        selector: '.hero__map', data: paulLevinRetailerList, googleMapsStylingOptions: {
          "center": {
            "lat": -34.397,
            "lng": 150.644
          },
          "zoom": 8,
          "styles": [
            {
              elementType: "geometry",
              stylers: [{color: "#f5f5f5"}]
            },
            {
              elementType: "labels.icon",
              stylers: [{visibility: "off"}]
            },
            {
              elementType: "labels.text.fill",
              stylers: [{color: "#616161"}]
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{color: "#f5f5f5"}]
            },
            {
              featureType: "administrative.country",
              elementType: "geometry.stroke",
              stylers: [{color: "#7d7d7d"}, {weight: 2}]
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{color: "#bdbdbd"}]
            },
            {
              featureType: "poi", elementType: "geometry",
              stylers: [{color: "#eeeeee"}]
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{color: "#757575"}]
            },
            {
              featureType: "poi.business",
              stylers: [{visibility: "off"}]
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{color: "#e5e5e5"}]
            },
            {
              featureType: "poi.park",
              elementType: "labels.text",
              stylers: [{visibility: "off"}]
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{color: "#9e9e9e"}]
            },
            {
              featureType: "road", elementType: "geometry",
              stylers: [{color: "#ffffff"}]
            },
            {
              featureType: "road.arterial",
              elementType: "labels.text.fill",
              stylers: [{color: "#757575"}]
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{color: "#dadada"}]
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{color: "#616161"}]
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{color: "#9e9e9e"}]
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{color: "#e5e5e5"}]
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{color: "#eeeeee"}]
            },
            {
              featureType: "water", elementType: "geometry",
              stylers: [{color: "#c9c9c9"}]
            },
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [{color: "#dbf0ff"}]
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{color: "#9e9e9e"}]
            },
            {
              featureType: "water", elementType: "labels.text.fill",
              stylers: [{color: "#9e9e9e"}]
            }]
        }
      });
    };
  }

  initGoogleMaps () {
    const d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.src = '//maps.googleapis.com/maps/api/js?libraries=geometry,places&sensor=false&ver=3&sensor=false&key=AIzaSyD1YDnsk3jhjaJ8FNd5oLRZn48-zFncnEo&callback=initGoogleMap&language=de';
    s.parentNode.insertBefore(g, s);
  }
}
